import type { Box, Camera } from "../native/geometry";
import {
  maximumZoom,
  minimumZoom,
  resetViewport,
  stepZoom,
  zoomAt,
} from "../native/viewport";

/** View-only commands preserve the text editor's focus/range and never enter history. */
export class NativeZoomControls {
  private root = document.querySelector<HTMLElement>(".native-zoom-control")!;
  private reset = document.getElementById("native-fit")!;
  private tooltip = document.createElement("div");
  constructor(
    private camera: Camera,
    area: () => Box,
    page: () => { width: number; height: number },
    blocked: () => boolean,
    private wheelMode: () => string,
    changed: () => void,
  ) {
    this.tooltip.id = "native-zoom-tooltip";
    this.tooltip.role = "tooltip";
    this.tooltip.hidden = true;
    this.root.append(this.tooltip);
    this.reset.removeAttribute("title");
    this.reset.setAttribute("aria-describedby", this.tooltip.id);
    this.root.addEventListener("pointerdown", (e) => e.preventDefault());
    this.reset.onpointerenter = (e) => {
      if (e.pointerType !== "touch") this.tooltip.hidden = false;
    };
    this.reset.onfocus = () => {
      this.tooltip.hidden = false;
    };
    this.reset.onblur = this.root.onpointerleave = () => {
      this.tooltip.hidden = true;
    };
    window.addEventListener(
      "keydown",
      (e) => {
        if (
          e.key !== "Escape" ||
          this.tooltip.hidden ||
          document.querySelector("dialog[open]")
        )
          return;
        this.tooltip.hidden = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true,
    );
    this.reset.onclick = () => {
      if (blocked()) return;
      resetViewport(camera, area(), page());
      changed();
    };
    for (const [id, direction] of [
      ["in", 1],
      ["out", -1],
    ] as const) {
      document.getElementById("native-zoom-" + id)!.onclick = () => {
        if (blocked()) return;
        const box = area();
        zoomAt(camera, stepZoom(camera.zoom, direction), {
          x: box.x + box.width / 2,
          y: box.y + box.height / 2,
        });
        changed();
      };
    }
  }
  render() {
    const percentage = Math.round(this.camera.zoom * 100);
    document.getElementById("native-zoom")!.textContent = percentage + "%";
    this.reset.setAttribute(
      "aria-label",
      `Масштаб ${percentage}%. Вернуть 100%`,
    );
    (document.getElementById("native-zoom-in") as HTMLButtonElement).disabled =
      this.camera.zoom >= maximumZoom;
    (document.getElementById("native-zoom-out") as HTMLButtonElement).disabled =
      this.camera.zoom <= minimumZoom;
    this.tooltip.textContent =
      (this.wheelMode() === "alt-wheel"
        ? "Alt + колесо мыши — изменить масштаб."
        : "Колесо мыши или Alt + колесо — изменить масштаб.") +
      " Нажмите на процент, чтобы вернуть 100%.";
  }
}
